import { environment } from 'src/environments/environment';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MediaService {

/* ------------------------------- Constructor ------------------------------ */

  constructor(private http: HttpClient) { }

    /* --------------------------------- Upload --------------------------------- */

    uploadMedia(formData: FormData): Observable<any> {
      console.log(formData);
      return this.http.post(`${environment.serverPath}/api/v1/file-upload/upload-s3`, formData, {
        reportProgress: true,
        observe: 'events',
      }).pipe(map((event) => {
        switch (event.type) {
          case HttpEventType.UploadProgress:
            const progress = Math.round(100 * event.loaded / event.total);
            return { status: 'progress', message: progress, event };
          case HttpEventType.Response:
            return event.body;
          default:
            return `Unhandled event: ${event.type}`;
        }
      })
      );
    }
}
